import React, { ReactNode } from 'react';
import NextLink, { LinkProps as NextLinkProps } from 'next/link';

interface Props extends NextLinkProps {
  href: string; // | NextLinkProps['href'];
  isExternal?: boolean;
  isShallow?: boolean;
  children?: ReactNode;
  target?: HTMLAnchorElement['target'];
  rel?: React.AnchorHTMLAttributes<HTMLAnchorElement>['rel'];
  className?: string;
  onFocus?: () => void;
  onBlur?: () => void;
  role?: string;
}

export default function Link({
  isExternal = false,
  isShallow = false,
  href,
  className,
  children,
  ...rest
}: Props) {
  return isExternal ? (
    <a href={href} target="_blank" rel="noopener noreferrer" {...rest} className={className}>
      {children}
    </a>
  ) : (
    <NextLink shallow={isShallow} href={href} {...rest} className={className}>
      {children}
    </NextLink>
  );
}
